var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-content"},[_c('navComponent',{attrs:{"activeName":_vm.activeName}}),_c('productContentBanner')],1)]),_c('div',{staticClass:"type-area"},[_c('div',{staticClass:"type-area-center"},[_c('productRecommendation')],1)]),_c('footerComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }